var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 732,
    viewBox: "0 0 1512 732",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_242_1498)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.367,
    cy: 183.69,
    rx: 255.367,
    ry: 183.69,
    transform: "matrix(-0.260238 0.965545 -0.786784 -0.617229 1512 226.757)",
    fill: "url(#paint0_radial_242_1498)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_242_1498)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 312,
    cy: 348,
    rx: 214,
    ry: 271,
    fill: "url(#paint1_radial_242_1498)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_242_1498",
    x: 1041.91,
    y: -11.5054,
    width: 518.219,
    height: 742.904,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_242_1498"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_242_1498",
    x: -2,
    y: -23,
    width: 628,
    height: 742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_242_1498"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_242_1498",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.367 183.69) rotate(90) scale(183.69 255.367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552885,
    stopColor: "#957BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_242_1498",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312 348) rotate(90) scale(271 214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51040D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552885,
    stopColor: "#CC656C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbs1);
export default __webpack_public_path__ + "static/media/Orbs1.c483b4b14e60933061f77bd1378a4689.svg";
export { ForwardRef as ReactComponent };